import { db } from "./db.js";

// ==================== CREATE ====================

async function createSubscription(data, userId, transaction = null) {
  const payload = { ...data, owner: userId };
  const col = db.collection("subscriptions");
  const newDocRef = col.doc(); // auto-generated id

  if (transaction) {
    transaction.set(newDocRef, payload);
    return { id: newDocRef.id, ...payload };
  }

  await newDocRef.set(payload);
  return { id: newDocRef.id, ...payload };
}

// ==================== READ ====================

async function getSubscription(subId) {
  if (!subId) return null;
  const subscription = await db.doc(`subscriptions/${subId}`).get();
  return subscription.exists ? { id: subscription.id, ...subscription.data() } : null;
}

async function getSubscriptionByUserId(userId) {
  const subsSnapshot = await db
    .collection("subscriptions")
    .where("owner", "==", userId)
    .limit(1)
    .get();

  if (subsSnapshot.empty) {
    return null;
  }
  
  const subDoc = subsSnapshot.docs[0];
  return { id: subDoc.id, ...subDoc.data() };
}

// ==================== UPDATE ====================

async function updateSubscription(subId, data, transaction = null) {
  const docRef = db.doc(`subscriptions/${subId}`);

  if (transaction) {
    transaction.update(docRef, data);
    return { id: subId, ...data };
  }

  await docRef.update(data);
  return { id: subId, ...data };
}

export { createSubscription, getSubscription, updateSubscription, getSubscriptionByUserId };
